
console.log(process.env);

const ENV_STAGE = process.env.REACT_APP_ENVIRONMENT.toUpperCase();
let sufixEnvironment = ENV_STAGE;

export const environment = {              
    REACT_APP_PAIS:process.env[`REACT_APP_PAIS`],
    REACT_APP_ADMIN_REPORTS:process.env[`REACT_APP_ADMIN_REPORTS_${sufixEnvironment}`] === 'true',
    REACT_APP_SERVER_URL:process.env[`REACT_APP_SERVER_URL_${sufixEnvironment}`],
    REACT_APP_SERVER_URL_SOFIA:process.env[`REACT_APP_SERVER_URL_SOFIA_${sufixEnvironment}`],
    REACT_APP_LOG_USER_REPORTS:process.env[`REACT_APP_LOG_USER_REPORTS_${sufixEnvironment}`],
    REACT_APP_MAX_LIMIT_CREDITS:process.env[`REACT_APP_MAX_LIMIT_CREDITS_${sufixEnvironment}`],
    REACT_APP_API_CONTROL_TRANSACCIONAL:process.env[`REACT_APP_API_CONTROL_TRANSACCIONAL_${sufixEnvironment}`],
    ENVIRONMENT:process.env['REACT_APP_ENVIRONMENT'],
    VERSION:process.env['REACT_APP_VERSION'], 
    REACT_APP_API_NIVELES_MATERIAS_OBJETIVOS:process.env[`REACT_APP_API_NIVELES_MATERIAS_OBJETIVOS_${sufixEnvironment}`],
    REACT_APP_API_OAS:process.env[`REACT_APP_API_OAS_${sufixEnvironment}`],
    REACT_APP_API_OAS_TP:process.env[`REACT_APP_API_OAS_TP_${sufixEnvironment}`]
};

//Manejamos el timeout en 1 hora para permitir nuevos registros de logs de login, esto se realiza por que por cada actualizacion del navegador generariamos registros de login
export const LOGIN_TIMEOUT = 60 * 60 * 1000; // 1 hora
